module.exports = __webpack_public_path__ + "img/swap.767ec54b.svg";